import { VuexModule, Module, Action, Mutation, getModule } from "vuex-module-decorators";
import store from "@/store";
import TicketModel from "@/models/createTicket/TicketModel";

export interface IHomeState {
  listTicket: TicketModel[];
  currentPage: number;
  hasMorePages: boolean;
  scrollPosition: number;
  isDataLoaded: boolean;
}

@Module({ dynamic: true, store, name: "home" })
class Home extends VuexModule implements IHomeState {
  public listTicket: TicketModel[] = [];
  public currentPage: number = 1;
  public hasMorePages: boolean = false;
  public scrollPosition: number = 0;
  public isDataLoaded: boolean = false;

  @Mutation
  public SET_LIST_TICKET(tickets: TicketModel[]): void {
    this.listTicket = tickets;
  }

  @Mutation
  public APPEND_LIST_TICKET(tickets: TicketModel[]): void {
    this.listTicket = [...this.listTicket, ...tickets];
  }

  @Mutation
  public SET_CURRENT_PAGE(page: number): void {
    this.currentPage = page;
  }

  @Mutation
  public SET_HAS_MORE_PAGES(hasMore: boolean): void {
    this.hasMorePages = hasMore;
  }

  @Mutation
  public SET_SCROLL_POSITION(position: number): void {
    this.scrollPosition = position;
  }

  @Mutation
  public SET_DATA_LOADED(loaded: boolean): void {
    this.isDataLoaded = loaded;
  }

  @Mutation
  public RESET_STATE(): void {
    this.listTicket = [];
    this.currentPage = 1;
    this.hasMorePages = false;
    this.scrollPosition = 0;
    this.isDataLoaded = false;
  }

  @Action
  public setListTicket(tickets: TicketModel[]): void {
    this.SET_LIST_TICKET(tickets);
  }

  @Action
  public appendListTicket(tickets: TicketModel[]): void {
    this.APPEND_LIST_TICKET(tickets);
  }

  @Action
  public setCurrentPage(page: number): void {
    this.SET_CURRENT_PAGE(page);
  }

  @Action
  public setHasMorePages(hasMore: boolean): void {
    this.SET_HAS_MORE_PAGES(hasMore);
  }

  @Action
  public setScrollPosition(position: number): void {
    this.SET_SCROLL_POSITION(position);
  }

  @Action
  public setDataLoaded(loaded: boolean): void {
    this.SET_DATA_LOADED(loaded);
  }

  @Action
  public resetState(): void {
    this.RESET_STATE();
  }
}

export const HomeModule = getModule(Home);
